import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "fixed-header" }
const _hoisted_3 = { class: "header_white" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { style: {"padding":"0 16px"} }
const _hoisted_6 = { class: "intro__info" }
const _hoisted_7 = { class: "h2" }
const _hoisted_8 = { class: "ftw-normal" }
const _hoisted_9 = { class: "fz-bigger" }
const _hoisted_10 = { class: "intro__details" }
const _hoisted_11 = { class: "intro__details-col" }
const _hoisted_12 = { class: "intro__details-title" }
const _hoisted_13 = {
  key: 0,
  class: "intro__details-text"
}
const _hoisted_14 = { style: {"font-size":"20px"} }
const _hoisted_15 = {
  key: 0,
  class: "intro__details-num",
  style: {"margin-left":"2px"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "intro__details-col" }
const _hoisted_18 = { class: "intro__details-title" }
const _hoisted_19 = { class: "intro__details-text" }
const _hoisted_20 = { class: "intro__details-num" }
const _hoisted_21 = {
  key: 0,
  class: "intro__details-col"
}
const _hoisted_22 = { class: "intro__details-title" }
const _hoisted_23 = { class: "intro__details-text" }
const _hoisted_24 = { class: "intro__details-num" }
const _hoisted_25 = {
  class: "intro__info-price price",
  style: {"margin-bottom":"16px"}
}
const _hoisted_26 = { class: "h2" }
const _hoisted_27 = {
  key: 0,
  class: "price__full"
}
const _hoisted_28 = { class: "options" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "label__spec-name" }
const _hoisted_31 = {
  class: "firstPageImages",
  style: {"margin":"16px 0"}
}
const _hoisted_32 = {
  key: 0,
  class: "vehicle-image-grid"
}
const _hoisted_33 = ["src", "onLoad", "alt"]
const _hoisted_34 = {
  class: "images",
  style: {"margin-top":"45px"}
}
const _hoisted_35 = {
  key: 0,
  class: "vehicle-image-grid"
}
const _hoisted_36 = ["src", "onLoad", "alt"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { style: {"page-break-after":"always"} }, null, -1)
const _hoisted_38 = { class: "h3 ttu" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_40 = { class: "word-blue" }
const _hoisted_41 = {
  class: "detail__row",
  style: {"flex-direction":"column"}
}
const _hoisted_42 = { class: "detail__col" }
const _hoisted_43 = { class: "detail__content" }
const _hoisted_44 = { class: "detail__title" }
const _hoisted_45 = {
  key: 0,
  class: "detail__tooltip"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon info",
  width: "13",
  height: "13"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#info-question" })
], -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "detail__item" }
const _hoisted_49 = {
  key: 0,
  class: "vehicle_message_container"
}
const _hoisted_50 = { class: "detail__name" }
const _hoisted_51 = { class: "detail__value" }
const _hoisted_52 = { class: "block" }
const _hoisted_53 = {
  class: "detail__row",
  style: {"flex-direction":"column"}
}
const _hoisted_54 = { class: "detail__col" }
const _hoisted_55 = { class: "detail__content" }
const _hoisted_56 = { class: "detail__title" }
const _hoisted_57 = {
  key: 0,
  class: "detail__tooltip"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon info",
  width: "13",
  height: "13"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#info-question" })
], -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "detail__item" }
const _hoisted_61 = {
  key: 0,
  class: "vehicle_message_container"
}
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = { class: "detail__name" }
const _hoisted_64 = { class: "detail__value" }
const _hoisted_65 = { class: "block" }
const _hoisted_66 = { class: "h3 ttu mb" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_68 = { class: "word-blue" }
const _hoisted_69 = {
  class: "col-lg-10 features__list mb",
  id: "main-features"
}
const _hoisted_70 = { class: "h3 ttu" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "word-blue" }, "+", -1)
const _hoisted_72 = { style: {"margin-top":"16px"} }
const _hoisted_73 = { class: "h3 ttu" }
const _hoisted_74 = { class: "list" }
const _hoisted_75 = {
  key: 1,
  class: "list-item fz-smaller"
}
const _hoisted_76 = { class: "h3 ttu" }
const _hoisted_77 = { class: "list" }
const _hoisted_78 = {
  key: 1,
  class: "list-item fz-smaller"
}
const _hoisted_79 = { class: "block" }
const _hoisted_80 = { class: "h3 ttu mb" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_82 = { class: "word-blue" }
const _hoisted_83 = { style: {"display":"flex","gap":"16px","flex-direction":"column"} }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "list" }
const _hoisted_86 = { class: "block" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "damages__wrapper" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("img", {
  class: "damages__car",
  src: "/img/car-detail/car-damage.svg",
  alt: "Car"
}, null, -1)
const _hoisted_90 = { class: "pin__wrap" }
const _hoisted_91 = { class: "damages" }
const _hoisted_92 = { class: "p-d-flex p-flex-colmn p-ai-center" }
const _hoisted_93 = { class: "pin__marks p-d-flex p-m-0" }
const _hoisted_94 = ["data-cat"]
const _hoisted_95 = { class: "pin__mark-title" }
const _hoisted_96 = { class: "pin__marks" }
const _hoisted_97 = {
  key: 0,
  class: "pin__mark",
  "data-cat": "crushed"
}
const _hoisted_98 = { class: "pin__mark-title" }
const _hoisted_99 = {
  key: 0,
  class: "pin__mark-num"
}
const _hoisted_100 = {
  key: 1,
  class: "pin__mark",
  "data-cat": "scratch"
}
const _hoisted_101 = { class: "pin__mark-title" }
const _hoisted_102 = {
  key: 0,
  class: "pin__mark-num"
}
const _hoisted_103 = {
  key: 2,
  class: "pin__mark",
  "data-cat": "dent"
}
const _hoisted_104 = { class: "pin__mark-title" }
const _hoisted_105 = {
  key: 0,
  class: "pin__mark-num"
}
const _hoisted_106 = {
  key: 3,
  class: "pin__mark",
  "data-cat": "break"
}
const _hoisted_107 = { class: "pin__mark-title" }
const _hoisted_108 = {
  key: 0,
  class: "pin__mark-num"
}
const _hoisted_109 = {
  key: 4,
  class: "pin__mark",
  "data-cat": "others"
}
const _hoisted_110 = { class: "pin__mark-title" }
const _hoisted_111 = {
  key: 0,
  class: "pin__mark-num"
}
const _hoisted_112 = {
  key: 1,
  class: "fz-bigger"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "damages__wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "damages__car",
    src: "/img/car-detail/car-damage.svg",
    alt: "Car",
    width: "100",
    height: "100"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "damages__success" })
], -1)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = {
  key: 0,
  style: {"page-break-after":"always"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_app_vehicle_options = _resolveComponent("app-vehicle-options")!
  const _component_p_divider = _resolveComponent("p-divider")!
  const _component_vue_tippy = _resolveComponent("vue-tippy")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "print-only",
    id: _ctx.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "logo",
          src: `/img/${_ctx.brandLabel}/logos/logo-color.svg`,
          alt: `${_ctx.brandLabel} logo`
        }, null, 8, _hoisted_4)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.initialCarDetails || _ctx.carDetailsCollection), (carDetailsData, carIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: carIndex,
        class: "layout__main car-detail content",
        id: "mainWrapper"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(carDetailsData?.brand?.name +
                                " " +
                                carDetailsData?.model +
                                " " +
                                carDetailsData?.finish +
                                " " +
                                carDetailsData?.powertrain?.gearbox?.name +
                                " " +
                                carDetailsData?.powertrain?.fueltype?.name), 1)
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(carDetailsData?.powertrain?.motorisation
                                ? carDetailsData?.powertrain?.motorisation
                                : "" + " " + carDetailsData?.finish), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.date" })
                ]),
                (carDetailsData?.firstregistration_date)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.getDayFromDate(
                                        carDetailsData?.firstregistration_date,
                                    )) + " ", 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getMonthFromDate(
                                            carDetailsData?.firstregistration_date,
                                        )), 1),
                      (carDetailsData?.firstregistration_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getYearFromDate(
                                            carDetailsData?.firstregistration_date,
                                        )), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_16, "-"))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.kmUsed" })
                ]),
                _createElementVNode("p", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(carDetailsData?.mileage), 1),
                  _createTextVNode(" km ")
                ])
              ]),
              (
                            carDetailsData?.powertrain?.specification
                                ?.emission_co2_wltp_combined
                        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, [
                      _createVNode(_component_i18n_t, { keypath: "carDetails.emissionCO2" })
                    ]),
                    _createElementVNode("p", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(// @ts-ignore
                                        carDetailsData?.powertrain?.specification
                                            ?.emission_co2_wltp_combined), 1),
                      _createTextVNode(" g/km ")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", _hoisted_26, [
                (
                                carDetailsData?.price_current?.list_price_euro
                            )
                  ? (_openBlock(), _createBlock(_component_app_format_currency, {
                      key: 0,
                      value: carDetailsData?.price_current
                                    ?.list_price_euro || 0
                                    
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              (carDetailsData?.price_previous)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_i18n_t, { keypath: "carDetails.ExclusiveVAT" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initialOptions?.[carDetailsData?.id] || [], (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "feature-wrapper",
                  class: "option",
                  key: index
                }, [
                  (option.icon_href)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        id: "feature-img",
                        src: option.icon_href,
                        alt: ""
                      }, null, 8, _hoisted_29))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(option.name), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.images[carDetailsData?.id]?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images[carDetailsData?.id].slice(0, 4), (image, imageIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: imageIndex,
                        class: "grid-item"
                      }, [
                        _createElementVNode("img", {
                          src: image.href_small,
                          class: "vehicle-print-image",
                          onLoad: ($event: any) => (_ctx.updateLoadedImages(carDetailsData?.id, image.id)),
                          alt: carDetailsData?.brand?.name + ' ' + carDetailsData?.model,
                          width: "480",
                          height: "360"
                        }, null, 40, _hoisted_33)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_ctx.images[carDetailsData?.id]?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images[carDetailsData?.id].slice(4), (image, imageIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: imageIndex,
                        class: "grid-item"
                      }, [
                        _createElementVNode("img", {
                          src: image.href_small,
                          class: "vehicle-print-image",
                          onLoad: ($event: any) => (_ctx.updateLoadedImages(carDetailsData?.id, image.id)),
                          alt: carDetailsData?.brand?.name + ' ' + carDetailsData?.model,
                          width: "480",
                          height: "360"
                        }, null, 40, _hoisted_36)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_37
          ]),
          _createElementVNode("div", {
            class: "block",
            ref_for: true,
            ref: "detail",
            id: "detail"
          }, [
            _createElementVNode("h3", _hoisted_38, [
              _createVNode(_component_i18n_t, { keypath: "carDetails.car" }),
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, [
                _createVNode(_component_i18n_t, { keypath: "carDetails.details" })
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.carDetailsColumn(carDetailsData, 0)), (group) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("h4", _hoisted_44, [
                      _createTextVNode(_toDisplayString(group.title) + " ", 1),
                      (group.info)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47)), [
                            [_directive_tippy, {
                                        content: group.info,
                                        placement: 'right',
                                        interactive: true,
                                    }]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        (item.name === 'vehicle_message')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("p", null, _toDisplayString(item.value), 1)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_50, _toDisplayString(item.name), 1),
                              _createElementVNode("div", _hoisted_51, _toDisplayString(item.value), 1)
                            ], 64))
                      ]))
                    }), 256))
                  ]))
                }), 256))
              ])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.carDetailsColumn(carDetailsData, 1)), (group) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("h4", _hoisted_56, [
                      _createTextVNode(_toDisplayString(group.title) + " ", 1),
                      (group.info)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_57, _hoisted_59)), [
                            [_directive_tippy, {
                                        content: group.info,
                                        placement: 'right',
                                        interactive: true,
                                    }]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (item.name === 'vehicle_message')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createElementVNode("p", {
                                innerHTML: item.value
                              }, null, 8, _hoisted_62)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_63, _toDisplayString(item.name), 1),
                              _createElementVNode("div", _hoisted_64, _toDisplayString(item.value), 1)
                            ], 64))
                      ]))
                    }), 256))
                  ]))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("h3", _hoisted_66, [
              _createVNode(_component_i18n_t, { keypath: "carDetails.main" }),
              _hoisted_67,
              _createElementVNode("span", _hoisted_68, [
                _createVNode(_component_i18n_t, { keypath: "carDetails.features" })
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_app_vehicle_options, {
                "vehicle-id": carDetailsData?.id,
                "show-label": true,
                size: 38,
                disableWowEffect: "true"
              }, null, 8, ["vehicle-id"])
            ]),
            (_ctx.isCarconnexPlusLabel(carDetailsData))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "specifications__block",
                  ref_for: true,
                  ref: "carconnexTitle",
                  id: "carconnexTitle"
                }, [
                  _createElementVNode("h3", _hoisted_70, [
                    _createTextVNode(_toDisplayString(_ctx.brandLabelText) + " ", 1),
                    _hoisted_71
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_i18n_t, { keypath: "carDetails.carconnexTitle" }, {
                      brandLabelText: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.brandLabelText), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_73, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.documents" })
                ]),
                _createElementVNode("ul", _hoisted_74, [
                  (_ctx.vehicleDocumentAvailability?.[carDetailsData?.id]?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.vehicleDocumentAvailability?.[carDetailsData?.id], (dto, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "list-item fz-smaller"
                        }, [
                          _createTextVNode(_toDisplayString(dto.documenttype.name) + ": ", 1),
                          (dto.available)
                            ? (_openBlock(), _createBlock(_component_i18n_t, {
                                key: 0,
                                keypath: "carDetails.available"
                              }))
                            : (_openBlock(), _createBlock(_component_i18n_t, {
                                key: 1,
                                keypath: "myOrders.notAvailable"
                              })),
                          _createTextVNode(" " + _toDisplayString(dto.from_date !== undefined ? "(" + dto.from_date + ")" : ""), 1)
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("li", _hoisted_75, [
                        _createVNode(_component_i18n_t, { keypath: "carDetails.documentAreNotAvailable" })
                      ]))
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_76, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.accessories" })
                ]),
                _createElementVNode("ul", _hoisted_77, [
                  (_ctx.vehicleAccessoryAvailability?.[carDetailsData?.id]?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.vehicleAccessoryAvailability?.[carDetailsData?.id], (dto, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "list-item fz-smaller"
                        }, [
                          _createTextVNode(_toDisplayString(dto.accessory.name) + ": ", 1),
                          (dto.available)
                            ? (_openBlock(), _createBlock(_component_i18n_t, {
                                key: 0,
                                keypath: "carDetails.available"
                              }))
                            : (_openBlock(), _createBlock(_component_i18n_t, {
                                key: 1,
                                keypath: "myOrders.notAvailable"
                              }))
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("li", _hoisted_78, [
                        _createVNode(_component_i18n_t, { keypath: "carDetails.accessoriesAreNotAvailable" })
                      ]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("h3", _hoisted_80, [
              _createVNode(_component_i18n_t, { keypath: "carDetails.full" }),
              _hoisted_81,
              _createElementVNode("span", _hoisted_82, [
                _createVNode(_component_i18n_t, { keypath: "carDetails.equipment" })
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              (_ctx.vehicleFactoryEquipments[carDetailsData?.id]?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("ul", _hoisted_85, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleFactoryEquipments[carDetailsData?.id], (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-item fz-smaller",
                          key: item
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            (_ctx.vehicleDamageRecord[carDetailsData?.id]?.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("div", _hoisted_90, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                        return (_openBlock(), _createBlock(_component_vue_tippy, {
                          key: index,
                          tag: "div",
                          "max-width": 300,
                          class: _normalizeClass(["pin tooltip__info", 'p' + record.location.id]),
                          "content-tag": "div",
                          "data-category": (record.types[0]?.name || '').toLowerCase(),
                          "data-number": record.location.id
                        }, {
                          content: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.types, (type, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "car-detail"
                              }, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("ul", _hoisted_93, [
                                      _createElementVNode("li", {
                                        class: "pin__mark p-m-0",
                                        "data-cat": type.id
                                      }, [
                                        _createElementVNode("span", _hoisted_95, _toDisplayString(type.name), 1)
                                      ], 8, _hoisted_94)
                                    ])
                                  ])
                                ]),
                                (record.types.length > 1)
                                  ? (_openBlock(), _createBlock(_component_p_divider, {
                                      key: 0,
                                      class: "p-my-2"
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["class", "data-category", "data-number"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_96, [
                    (_ctx.isDamageLabel(1, carDetailsData?.id))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_97, [
                          _createElementVNode("span", _hoisted_98, [
                            _createVNode(_component_i18n_t, { keypath: "carDamage.crushed" }),
                            _createTextVNode(" : ")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                                        record.types.find((type) => {
                                            return type.id === 3;
                                        })
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(record.location.id) + ", ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDamageLabel(2, carDetailsData?.id))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_100, [
                          _createElementVNode("span", _hoisted_101, [
                            _createVNode(_component_i18n_t, { keypath: "carDamage.scratch" }),
                            _createTextVNode(" : ")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                                        record.types.find((type) => {
                                            return type.id === 2;
                                        })
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(record.location.id) + ", ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDamageLabel(1, carDetailsData?.id))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                          _createElementVNode("span", _hoisted_104, [
                            _createVNode(_component_i18n_t, { keypath: "carDamage.dent" }),
                            _createTextVNode(" : ")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                                        record.types.find((type) => {
                                            return type.id === 1;
                                        })
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(record.location.id) + ", ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDamageLabel(4, carDetailsData?.id))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_106, [
                          _createElementVNode("span", _hoisted_107, [
                            _createVNode(_component_i18n_t, { keypath: "carDamage.break" }),
                            _createTextVNode(" : ")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                                        record.types.find((type) => {
                                            return type.id === 4;
                                        })
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(record.location.id) + ", ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDamageLabel(5, carDetailsData?.id))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_109, [
                          _createElementVNode("span", _hoisted_110, [
                            _createVNode(_component_i18n_t, { keypath: "carDamage.others" }),
                            _createTextVNode(" : ")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleDamageRecord[carDetailsData?.id], (record, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (
                                        record.types.find((type) => {
                                            return type.id === 5;
                                        })
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(record.location.id) + ", ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
          ])
        ]),
        (carIndex < _ctx.carDetailsCollection.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_115))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 8, _hoisted_1))
}